// import { removeMaskMoney } from "./utils";
export const rules = {
  required: (value) => !!value || "rules.required",
  maxLength: (value) => value.length <= 30 || "rules.maxLength",
  date: (value) => {
    const pattern = /^\d{4}-(0?[1-9]|1[012])-(0?[1-9]|[12][0-9]|3[01])$/;
    return pattern.test(value) || "rules.date";
  },
  email: (value) => {
    const pattern =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(value) || "rules.email";
  },
  numberPositive: (value) => {
    let numV = value;
    // if (typeof numV === "string") numV = removeMaskMoney(value);
    return numV >= 0 || "rules.numberPositive";
  },
  password: (value) => {
    const pattern =
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[$*&@#!;=+\-_,.])[0-9a-zA-Z$*&@#!;=+\-_,.]{8,}$/;
    return pattern.test(value) || "rules.password";
  },
  reppeat: (base, value) => {
    return base === value || "rules.reppeat";
  },
};
